import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {SUPPLIER_TYPE_AUTOLAND, SUPPLIER_TYPE_AUTOPARTNERSA, SUPPLIER_TYPE_INTERCARS} from "../SupplierTypes";
import InterCars from "./SupplierStage1/InterCars";
import AutoPartnerSa from "./SupplierStage1/AutoPartnerSa";
import apiUser from "../../../apiUser";
import {each} from "lodash";
import {toast} from "react-toastify";
import EmailToPhProcess from "./SupplierStage1/EmailToPhProcess";
import AutoLand from "./SupplierStage1/AutoLand";
import {withTranslation} from "react-i18next";

class SupplierStage1Form extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {},
      errors: {},
    }
  }

  onSubmit = () => {
    this.props.onSavingStart()
    this.setState({
      errors: {},
    })

    const formData = new FormData();
    formData.append('data[type]', this.props.supplierType)

    each(this.state.data, (value, key) => formData.append(`data[${key}]`, value))

    apiUser.suppliers.createStage1(formData)
      .then(supplier => {
        toast.success(this.props.t('stage_1_form.integration_process_started'));

        this.props.onSaved(supplier)
      })
      .catch(res => {
        this.setState({
          errors: res?.response?.data?.children ?? {},
        })
      })
      .finally(() => {
        this.props.onSavingStop()
      })
  }

  getForm = () => {
    const props = {
      errors: this.state.errors,
      onChange: data => this.setState({data}),
    }

    if(this.props.supplierType === SUPPLIER_TYPE_INTERCARS){
      return <InterCars {...props} />
    }else if(this.props.supplierType === SUPPLIER_TYPE_AUTOPARTNERSA){
      return <AutoPartnerSa {...props} />
    }else if(this.props.supplierType === SUPPLIER_TYPE_AUTOLAND){
      return <AutoLand {...props} />
    }

    return <EmailToPhProcess {...props} />
  }

  render() {

    return (
      <div>
        {this.getForm()}

        <span
          className="mt-5 d-block cursor-pointer text-secondary"
          onClick={() => this.props.onSkipStage1()}
        >{this.props.t('stage_1_form.already_have_data')}</span>
      </div>
    );
  }
}

SupplierStage1Form.propTypes = {
  onSkipStage1: PropTypes.func.isRequired,
  onSaved: PropTypes.func.isRequired,
  onSavingStart: PropTypes.func.isRequired,
  onSavingStop: PropTypes.func.isRequired,
};

export default withTranslation('supplier_create', {withRef:true})(SupplierStage1Form);